import BankAccount from './bank-account-container';

export default BankAccount;